import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { TrackerChart } from "../../components/Trackers/Charts/TrackerChart";
import { ChartDayOffsets } from "../../components/Trackers/Charts/helpers";
import { useEffect, useState } from "react";
import { UserTrackerValue, useGetUserTrackerValuesFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { t } from "i18next";

export const WaterTrackerChart = () => {
  const today = new Date();
  const [dateFrom, setDateFrom] = useState<Date>(today.addDays(ChartDayOffsets.week));
  const { fetchTrackerDataFromDate, getCurrentTrackerValue } = useTrackerContext();
  const {
    data: waterTrackerData,
    mutate,
    isLoading,
    error,
  } = useGetUserTrackerValuesFunctionRequest({
    from: dateFrom.toDateOnlyString(),
    to: today.toDateOnlyString(),
    trackerType: TrackerType[TrackerType.Water],
  });

  useEffect(() => {
    fetchTrackerDataFromDate(TrackerType.Water, dateFrom);
  }, [dateFrom, fetchTrackerDataFromDate]);

  useEffect(() => {
    mutate();
  }, [mutate, getCurrentTrackerValue]);

  const mappedData: UserTrackerValue[] = waterTrackerData?.values.map((data) => data) ?? [];

  return (
    <TrackerChart
      trackerType={TrackerType[TrackerType.Water]}
      heading={t("wellbeing.trackers.water.chart.heading")}
      dateRange={{ startDate: dateFrom, endDate: today }}
      yAxisStepSize={100}
      yAxisLabel={t("wellbeing.trackers.water.chart.yLabel")}
      loading={isLoading}
      showError={error !== undefined}
      data={mappedData}
      reload={() => mutate()}
      onChartViewOffsetChange={(offset) => setDateFrom(today.addDays(offset))}
      initialChartViewOffset={ChartDayOffsets.week}
    />
  );
};
